// extracted by mini-css-extract-plugin
export var explorer = "x_s";
export var footer = "x_C";
export var footer__inner = "x_bH";
export var footer__logo = "x_bJ";
export var footer__mail = "x_bK";